<template>
    <img src="@/assets/icons/report.svg" class="w-[1.288rem] h-[1.288rem] md:w-[1.40rem] md:h-[1.40rem] lg:w-[1.513rem] lg:h-[1.513rem] 3xl:w-[1.61rem] 3xl:h-[1.61rem]" alt />
</template>
